export const money = (n) => `$${(Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function calcTotals(items, depositType, depositValue) {
  const total = Math.round((items || []).reduce((s, li) => s + (Number(li.quantity) || 0) * (Number(li.unit_price) || 0), 0) * 100) / 100;
  let deposit = 0;
  if (depositType === "percent") deposit = Math.round(total * Math.min(Number(depositValue) || 0, 100)) / 100;
  if (depositType === "fixed") deposit = Math.min(Number(depositValue) || 0, total);
  return { total, deposit };
}

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "");

export const STATUS_LABELS = {
  draft: "Draft", sent: "Sent", viewed: "Viewed", signed: "Signed", void: "Void",
  deposit_paid: "Deposit paid", paid: "Paid",
};
